import {
  React,
  Component,
  helpers,
} from 'imports/CommonImports';

import {
  PostulationFormWithSteps,
} from 'imports/ComponentsImports';

import {
  GreyColor1,
  HightlightSoftColor,
  ModalWithChildren,
} from 'imports/DesignImports';

import {
  FullCircleIcon,
  ViewIcon,
} from 'imports/IconsImports';

import {
  IconButton,
} from 'material-ui';

import './ProjectTable.css';
import DataTables from 'material-ui-datatables';

const keyToLabel = {
  'nombre': 'Nombre',
  'area': 'Área',
  'implementado': 'Año',
  'novedad': 'Grado de novedad',
  'solucion': 'Solución',
  'beneficio': 'Beneficio',
  'aporte': 'Aporte',
}

const styles = {
  tableHeaderColumn: {
    backgroundColor: GreyColor1,
    display: 'flex',
    alignItems: 'center'
  },
  tableRow: {
    display:'flex',
  },
  tableRowColumn: {
    backgroundColor: '#FFFFFF',
  },
  footerToolbar: {
    backgroundColor: '#FFFFFF'
  },
  verySmallColumn: {
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'flex',
    alignItems: 'center',
  },
  smallColumn: {
    flex: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'flex',
    alignItems: 'center',
  },
  mediumColumn: {
    flex: 4,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'flex',
    alignItems: 'center',
  },
  column: {
    flex: 6,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'flex',
    alignItems: 'center',
  }
}

export default class ProjectTable extends Component {
  state = {
    tableColumns: [],
    tableData: [],
    project: null,
    postulationForm: false,
    loadingData: true,
  }

  componentDidMount() {
    this.setTable(this.props);
  }

  componentWillReceiveProps(nextProps){
    this.setTable(nextProps);
    if(nextProps.changeData){
      this.setState({selectedRows: []});
    }
  }

  render() {
    return (
      <div>
        <DataTables
          height={'auto'}
          showRowHover={true}
          columns={this.state.tableColumns}
          data={this.state.tableData}
          showFooterToolbar={false}
          onCellClick={this.handleCellClick}
          onSortOrderChange={this.handleSortOrderChange}
          onRowSelection={this.handleRowSelection}
          showCheckboxes={true}
          selectable={true}
          multiSelectable={true}
          page={1}
          count={100}
          selectedRows={this.state.selectedRows}
          tableHeaderStyle={styles.tableHeader}
          tableHeaderColumnStyle={styles.tableHeaderColumn}
          tableRowStyle={styles.tableRow}
          tableRowColumnStyle={styles.tableRowColumn}
          footerToolbarStyle={styles.footerToolbar}
          ref={(table) => this.table = table}
        />
        { this.state.postulationForm ?
          <ModalWithChildren
            project={this.state.project}
            children={
              <PostulationFormWithSteps filterData={this.props.filterData} project={this.state.project} currency={this.props.company_currency}/>
            }
            cancel={() => this.setState({project: null, postulationForm: false})}
            confirm={() => this.setState({project: null, postulationForm: false})}/>
          : null
        }
      </div>
    )
  }

  setTable = (props) => {
    let tableColumns = []
    let tableData = []
    props.headers.forEach((header) => {
      if(header === 'aporte'){
        let year = props.projects.length > 0 && props.projects[0].indicator.length > 0 ? (new Date(props.projects[0].indicator[props.projects[0].indicator.length - 1].date)).getFullYear() : (new Date(Date.now())).getFullYear() + 1
        tableColumns.push({
          key: header,
          label: keyToLabel[header] + ' ' + year,
          sortable: true,
          style: styles.column,
          render: (attribute, all) => <p className='table-column' title={attribute}>{attribute}</p>
        })
      }
      else if(header === 'implementado'){
        tableColumns.push({
          key: header,
          label: keyToLabel[header] || header,
          sortable: true,
          style: styles.smallColumn,
          render: (attribute, all) => <p className='table-column' title={attribute}>{attribute}</p>
        })
      }
      else{
        tableColumns.push({
          key: header,
          label: keyToLabel[header] || header,
          sortable: true,
          style: ['novedad', 'solucion', 'beneficio', 'nombre'].includes(header) ? styles.column : styles.mediumColumn,
          render: (attribute, all) => <p className='table-column' title={attribute}>{attribute}</p>
        })
      }
    })

    //Ball to indicate if project has been manually forced
    tableColumns.push({
      key: 'forzado',
      label: <FullCircleIcon color={HightlightSoftColor} />,
      sortable: true,
      style: styles.verySmallColumn,
      render: (attribute, all) => <p className='table-column' title={attribute}>{attribute}</p>
    })

    // View button
    tableColumns.push({
      key: 'ver',
      label: 'Acción',
      style: styles.smallColumn,
      render: (attribute, all) => <p className='table-column' title={attribute}>{attribute}</p>
    })

    props.projects.forEach((project) => {
      tableData.push({
        nombre: project.information.name,
        area: project.information.area.name,
        implementado: (new Date(project.information.start_date)).getFullYear(),
        novedad: this.getNames(project.options.filter((option) => option.filter_id === 11)),
        solucion: this.getNames(project.options.filter((option) => option.filter_id === 1)),
        beneficio: this.getNames(project.options.filter((option) => option.filter_id === 21)),
        ver: (<IconButton tooltip="Ver" tooltipPosition="top-right" onClick={(event) => this.viewPostulation(event, project)}><ViewIcon/></IconButton>),
        forzado: project.isForced ? <FullCircleIcon color={HightlightSoftColor} /> : null,
        aporte: props.headers.includes('aporte') ? props.currency + ' ' + helpers.numberWithDots(project.indicator[project.indicator.length - 1].value) : 0,
      })
    })
    this.setState({
      tableColumns: tableColumns,
      tableData: tableData,
      loadingData: false,
    }, this.setStyles)
  }

  setStyles = () => {
    var tds = document.getElementsByTagName("td");
    var ths = document.getElementsByTagName("th");
    for (var i = 0; i < tds.length; i++) {
      tds[i].style['display'] = 'flex';
      tds[i].style['alignItems'] = 'center';
    }
    for (var i = 0; i < ths.length; i++) {
      ths[i].style['display'] = 'flex';
      ths[i].style['alignItems'] = 'center';
    }
  }

  sort = (a, b, key) => {
    if(key === 'forzado')
      return 1;
    if(a[key] < b[key])
      return -1;
    if(a[key] > b[key])
      return 1;
    return 0;
  }

  reverseSort = (a, b, key) => {
    if(key === 'forzado')
      return 1;
    if(a[key] > b[key])
      return -1;
    if(a[key] < b[key])
      return 1;
    return 0;
  }

  viewPostulation = (event, project) => {
    event.stopPropagation();
    this.setState({postulationForm: true, project: project});
  }

  handleCellClick = (rowIndex, columnIndex, row, column) => {
    // console.log('rowIndex: ' + rowIndex + ' columnIndex: ' + columnIndex);
  }

  handleRowSelection = (selectedRows) => {
    this.setState({selectedRows: selectedRows});
    this.props.manualProjectsOperation(this.props.projects.filter((project, i) => selectedRows.includes(i)));
  }

  handleSortOrderChange = (key, order) => {
    let tableData = this.state.tableData;
    let selectedProjects = this.state.tableData.filter((project, i) => this.state.selectedRows.includes(i))
    let newSelectedRows = []
    if(order === 'asc'){
      tableData.sort((a, b) => this.sort(a, b, key))
    }
    else{
      tableData.sort((a, b) => this.reverseSort(a, b, key))
    }
    tableData.forEach((project, i) => {
      if(selectedProjects.includes(project)){
        newSelectedRows.push(i)
      }
    })
    this.setState({tableData: tableData, selectedRows: newSelectedRows})
  }

  handleCellClick = () => {
    this.setState({modalWithChildren: true});
  }

  getField = (project, header) => {
    switch (header) {
      case 'Nombre del proyecto':
        return project.information.name;
      case 'Área':
        return project.information.area.name;
      case 'Líder':
        return project.information.leader_first_name + ' ' + project.information.leader_last_name;
      case 'Implementado el':
        return project.information.start_date;
      case 'Grado de novedad':
        return project.options.filter((option) => option.filter_id === 11).map(option => option.option.name)[0];
      case 'Solución':
        return project.options.filter((option) => option.filter_id === 1).map(option => option.option.name)[0];
      case 'Beneficio':
        return project.options.filter((option) => option.filter_id === 21).map(option => option.option.name)[0];
      default:
        break;
    }
  }

  getNames = (options) => {
    let totalName = '';
    options.map((option) => option.option.name).forEach((name) => totalName = totalName + name + ', ');
    return totalName.substring(0, totalName.length - 2);
  }

  setClassNameToTD = () => {
    var tds = document.getElementsByTagName('td');
  }
}



// WEBPACK FOOTER //
// ./src/components/common/ProjectTable.js